import React, { useEffect, useMemo } from "react";
import { S3_MENU_FOLDER } from "../../store/constants";
import CuiratoLogoTransparent from "../../assets/CuiratoLogoTransparent.png";
import ExploreStoryLanding from "../../assets/ExploreStoryLanding.png";
import ExploreStoryLanding1 from "../../assets/ExploreStoryLanding1.png";
import ExploreStoryLanding2 from "../../assets/ExploreStoryLanding2.png";
import ExploreChef20 from "../../assets/ExploreChef20.png";
import ExploreChef21 from "../../assets/ExploreChef21.png";
import ExploreChef22 from "../../assets/ExploreChef22.png";
import ExploreChefUser1 from "../../assets/ExploreChefUser1.png";
import ExploreStoryLanding4 from "../../assets/ExploreStoryLanding4.png";
import Bookmark from "../../assets/Bookmark.png";
import Share from "../../assets/Share.png";
import DownArrowSvgIcon from "../../assets/ReactSvg/DownArrowSvgIcon";
import SwipeUpArrowSvgIcon from "../../assets/ReactSvg/SwipeUpArrowSvgIcon";
import Stories from "react-insta-stories";
import "./landingPage1.css";
import TickIconSvg from "../../assets/ReactSvg/TickIconSvg";

const getResponsiveGap = () => {
  const screenHeight = window.innerHeight;

  const minHeight = 659;
  const maxHeight = 809;
  const minGap = 20;
  const maxGap = 40;

  if (screenHeight <= minHeight) return minGap;
  if (screenHeight >= maxHeight) return maxGap;

  const ratio = (screenHeight - minHeight) / (maxHeight - minHeight);
  return minGap + ratio * (maxGap - minGap);
};

const gap = getResponsiveGap();

export const LandingStory01 = ({
  handleCancel,
  action,
  index,
  activeIndex,
}) => {
  return (
    <div className="landingStoryContainer-" title="Food that touches your soul">
      {/* <button
        type="button"
        className="landingStorySkipBtn"
        onClick={(e) => {
          e.stopPropagation();
          handleCancel && handleCancel();
        }}
        onTouchEnd={(e) => {
          e.stopPropagation();
          handleCancel && handleCancel();
        }}
      >
        Skip
      </button> */}

      <div className="landingStory01Content">
        <h1 className="landingStory01Headline Satoshi">
          Food that touches your soul
          <br />
          without hurting your body.
        </h1>

        <div style={{ marginBottom: 80 }} className="landingStory01FeaturesGrid">
          <div className="landingStory01FeatureColumn">
            <div className="landingStory01FeatureItem">
              <TickIconSvg />
              <span className="landingStory01FeatureText Satoshi">
                Unadulterated food
              </span>
            </div>

            <div className="landingStory01FeatureItem">
              <TickIconSvg />
              <span className="landingStory01FeatureText Satoshi">Clean kitchen</span>
            </div>

            <div className="landingStory01FeatureItem">
              <TickIconSvg />
              <span className="landingStory01FeatureText Satoshi">
                Made with precision
              </span>
            </div>
          </div>

          <div className="landingStory01FeatureColumn">
            <div className="landingStory01FeatureItem">
              <TickIconSvg />
              <span className="landingStory01FeatureText Satoshi">
                No harmful ingredients
              </span>
            </div>

            <div className="landingStory01FeatureItem">
              <TickIconSvg />
              <span className="landingStory01FeatureText Satoshi">
                Authentic recipes
              </span>
            </div>
          </div>
        </div>

        <div className="landingStory01SwipeUpWrapper">
          <svg
            className="landingStory01SwipeUpChevron"
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 7L7 1.5L13 7"
              stroke="#686868"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="landingStory01SwipeUpLabel">
            Swipe up to know more
          </span>
        </div>
      </div>
    </div>
  );
};

export const LandingStory02 = ({
  handleCancel,
  action,
  index,
  activeIndex,
}) => {
  return (
    <div
      className="landingStoryContainer-"
      title="Discover Culinary experts around you"
    >
      {/* <button
        type="button"
        className="landingStorySkipBtn"
        onClick={(e) => {
          e.stopPropagation();
          handleCancel && handleCancel();
        }}
        onTouchEnd={(e) => {
          e.stopPropagation();
          handleCancel && handleCancel();
        }}
      >
        Skip
      </button> */}

      <div className="landingStory02Content">
        <h1 className="landingStory02Headline Satoshi">
          Discover Culinary experts
          <br />
          around you
        </h1>

        <p style={{ paddingBottom: 15 }} className="landingStory02Subtitle Satoshi">
          Honest restaurant founders and professional chefs
          <br />
          serving authentic food experiences.
        </p>
      </div>
    </div>
  );
};

export const LandingStory03 = ({
  handleCancel,
  action,
  index,
  activeIndex,
}) => {
  return (
    <div
      className="landingStoryContainer-"
      title="Discover Culinary experts around you"
    >
      {/* <button
        type="button"
        className="landingStorySkipBtn"
        onClick={(e) => {
          e.stopPropagation();
          handleCancel && handleCancel();
        }}
        onTouchEnd={(e) => {
          e.stopPropagation();
          handleCancel && handleCancel();
        }}
      >
        Skip
      </button> */}

      <div className="landingStory02Content">
        <h1 className="landingStory02Headline Satoshi">
          Verified by Food Curators
        </h1>

        <p style={{ marginBottom: 20 }} className="landingStory02Subtitle Satoshi">
          Curators are local food journalists. They visit the
          <br />
          restaurant anonymously, taste the food and verify the
          <br />
          experts.
        </p>
      </div>
    </div>
  );
};

export const LandingStory04 = ({
  handleCancel,
  action,
  index,
  activeIndex,
  onGeoLocationClickHandler
}) => {
  return (
    <div className="landingStoryContainer-" title="Food that touches your soul">
      {/* <button
        type="button"
        className="landingStorySkipBtn"
        onClick={(e) => {
          e.stopPropagation();
          handleCancel && handleCancel();
        }}
        onTouchEnd={(e) => {
          e.stopPropagation();
          handleCancel && handleCancel();
        }}
      >
        Skip
      </button> */}

      <div className="landingStory01Content">
        <h1 className="landingStory01Headline Satoshi">
          Book food experiences
        </h1>
        <p style={{ paddingBottom: 12 }} className="landingStory02Subtitle Satoshi">
          Custom meals curated for you by experts, curators and content creators.

        </p>


        <div className="landingStory01FeaturesGrid">
          <div className="landingStory01FeatureColumn">
            <div className="landingStory01FeatureItem">
              <TickIconSvg />
              <span className="landingStory01FeatureText Satoshi">
                Daily meal
              </span>
            </div>

            <div className="landingStory01FeatureItem">
              <TickIconSvg />
              <span className="landingStory01FeatureText Satoshi">Monsoon menu</span>
            </div>

            <div className="landingStory01FeatureItem">
              <TickIconSvg />
              <span className="landingStory01FeatureText Satoshi">
                What I suggest
              </span>
            </div>
          </div>

          <div className="landingStory01FeatureColumn">
            <div className="landingStory01FeatureItem">
              <TickIconSvg />
              <span className="landingStory01FeatureText Satoshi">
                Weekly specials
              </span>
            </div>

            <div className="landingStory01FeatureItem">
              <TickIconSvg />
              <span className="landingStory01FeatureText Satoshi">
                What i had
              </span>
            </div>
          </div>
        </div>


      </div>
      <div style={{ margin: 0 }} className="charsi-banner-wrapper">
        <div
          style={{
            width: 'stretch', padding: '12px 18px', margin: "0px",
            position: "absolute",
            bottom: "10px",
            left: "18px",
            right: "18px",
            zIndex: 1002
          }}
          className="charsi-banner"
          onClick={() => {
            onGeoLocationClickHandler && onGeoLocationClickHandler(false); // 2. call it
            // handleCancel();
          }}
        >
          <span className="charsi-text">
            Explore culinary experiences around me
          </span>
        </div>
      </div>
    </div>
  );
};

// const LandingPage1 = ({ handleCancel, index, activeIndex, setActiveIndex }) => {
//  const stories = useMemo(
//   () => [
//     {
//       url: "",
//       content: ({ action, isPaused, index }) => (
//         <LandingStory01
//           handleCancel={handleCancel}
//           action={action}
//           isPaused={isPaused}
//         />
//       ),
//     },
//     {
//       url: "",
//       content: ({ action, isPaused, index }) => (
//         <Content2
//           handleCancel={handleCancel}
//           action={action}
//           isPaused={isPaused}
//         />
//       ),
//     },
//     {
//       url: "",
//       content: ({ action, isPaused, index }) => (
//         <Content3
//           handleCancel={handleCancel}
//           action={action}
//           isPaused={isPaused}
//         />
//       ),
//     },
//   ],
//   [handleCancel, activeIndex]
// );

//   const onAllStoriesEnd = () => {
//     handleCancel();
//   };

//   return (
//    <Stories
//       stories={stories}
//       instaIndex={index}
//       loop
//       width="100%"
//       height="100dvh"
//       onAllStoriesEnd={onAllStoriesEnd}
//       onStoryStart={(s, idx) => setActiveIndex(idx)}
//     />
//   );
// };

// export default LandingPage1;
